import { render, staticRenderFns } from "./ServConDialog.vue?vue&type=template&id=656845ff"
import script from "./ServConDialog.vue?vue&type=script&lang=js"
export * from "./ServConDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports